module.exports = __webpack_public_path__ + "static/ft-adviser-rsz-0896cf76056ed3d0c06a21ec2585a2e8.png";